import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changePasswordAsync, logout } from "../../redux/slice/auth/authSlice";
import { NotificationManager } from "react-notifications";
import { useNavigate } from "react-router-dom";
import Loader from "components/loader";


const ChangePassword = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { userdata, isAuthenticated } = useSelector((state) => state.authSlice);
    const profileData = useSelector((state) => state.authSlice.profileData);
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        setError('');

        // Validation
        if (!oldPassword || !newPassword || !confirmPassword) {
            setError('All fields are required.');
            setLoading(false)
            return;
        }
        if (newPassword !== confirmPassword) {
            setError('New password and confirm password do not match.');
            setLoading(false)
            return;
        }
        const data = {
            user_id: profileData?._id, // Replace with actual user ID
            name: profileData?.name,
            user_name: profileData?.user_name,
            user_type: profileData?.user_type,
            old_password: oldPassword,
            new_password: newPassword,
            con_password: confirmPassword,
            master_id: profileData?.master_id,
            masters: profileData?.masters
        };
        try {
            if (isAuthenticated) {
                const response = await dispatch(changePasswordAsync(data)).unwrap();
                NotificationManager.success(response.message, '', 1000);
                // Logout user or redirect after success
                setLoading(false)
                setOldPassword('');
                setNewPassword('');
                setConfirmPassword('');
                dispatch(logout());
                navigate('/');
            }
        } catch (error) {
            console.log(error)
            setLoading(false)
            // NotificationManager.error(error.message, '', 3000);
        }
    };

    const togglePasswordVisibility = (id) => {
        const passwordInput = document.getElementById(id);
        const toggleButton = document.getElementById(`toggle-${id}`);

        if (passwordInput.type === 'password') {
            passwordInput.type = 'text';
            toggleButton.innerHTML = '<i class="fa fa-eye-slash" aria-hidden="true"></i>';
        } else {
            passwordInput.type = 'password';
            toggleButton.innerHTML = '<i class="fa fa-eye" aria-hidden="true"></i>';
        }
    }

    return (
        <>
            {loading && <Loader />}
            <div className='relative min-w-full'>
                <form onSubmit={handleSubmit}>
                    <div className='grid grid-cols-12 lg:px-[6px] mt-[.5rem] lg:mt-0'>
                        <div className='col-span-12'>
                            <div className='relative w-full'>
                                <p className='bg-[#18adc5] text-[#fff] text-[14px] font-bold h-[28px] leading-[19px] m-0 pl-[7px] pr-[10px] py-[6px] capitalize'>Change Password</p>
                            </div>
                            <div className="bg-[#fff] text-[#000] mb-[10px] min-h-[500px] w-full">
                                <div className="grid grid-cols-12 !pt-4 !ml-0 !mr-0 px-[6px] flex-wrap">
                                    <div className="col-span-12 lg:col-span-4 relative w-full px-[6px]">
                                        <div className="">
                                            <div className="text-[15px] relative mb-4">
                                                <label className="inline-block mb-[.5rem]" htmlFor="oldPassword">Old Password:</label>
                                                <input type="password" name="oldPassword" id="oldPassword" className="text-[12px] h-[30px] pl-[2px] pr-[5px] py-[5px] bg-clip-padding bg-[#fff] border-[1px] border-[solid] border-[#ced4da] rounded-[.25rem] text-[#495057] block font-normal leading-normal w-full" value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} />
                                                <span className="text-[#0e778f] text-[14px] absolute right-[8px] top-[35px]" id="toggle-oldPassword" onClick={() => togglePasswordVisibility('oldPassword')}>
                                                    <i className="fa fa-eye-slash" aria-hidden="true"></i>
                                                </span>
                                            </div>
                                            <div className="text-[15px] relative mb-4">
                                                <label className="inline-block mb-[.5rem]" htmlFor="newPassword">New Password:</label>
                                                <input type="password" name="newPassword" id="newPassword" className="text-[12px] h-[30px] pl-[2px] pr-[5px] py-[5px] bg-clip-padding bg-[#fff] border-[1px] border-[solid] border-[#ced4da] rounded-[.25rem] text-[#495057] block font-normal leading-normal w-full" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
                                                <span className="text-[#0e778f] text-[14px] absolute right-[8px] top-[35px]" id="toggle-newPassword" onClick={() => togglePasswordVisibility('newPassword')}>
                                                    <i className="fa fa-eye-slash" aria-hidden="true"></i>
                                                </span>
                                            </div>
                                            <div className="text-[15px] relative mb-4">
                                                <label className="inline-block mb-[.5rem]" for="text">Confirm Password:</label>
                                                <input type="password" name="confirmPassword" id="confirmPassword" className="text-[12px] h-[30px] pl-[2px] pr-[5px] py-[5px] bg-clip-padding bg-[#fff] border-[1px] border-[solid] border-[#ced4da] rounded-[.25rem] text-[#495057] block font-normal leading-normal w-full" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                                                <span className="text-[#0e778f] text-[14px] absolute right-[8px] top-[35px]" id="toggle-confirmPassword" onClick={() => togglePasswordVisibility('confirmPassword')}>
                                                    <i className="fa fa-eye-slash" aria-hidden="true"></i>
                                                </span>
                                            </div>
                                            {error && <p className="text-red-600">{error}</p>}
                                            <div className="text-[15px] relative mt-[2rem]">
                                                <button type="submit" className="bg-[linear-gradient(-180deg,_#5ecbdd,_#146578)] border-[1px] border-[solid] border-[#146578] text-[#fff] rounded-[3px] text-[14px] outline-[none] px-[20px] py-[5px] text-center inline-block font-normal leading-normal" disabled={loading}>Update</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div >
                    </div >
                </form>
            </div >
        </>
    )
}
export default ChangePassword